// extracted by mini-css-extract-plugin
module.exports = {"common-title-tip":"index_common-title-tip_2puzk"};